import { render, staticRenderFns } from "./textStyleEditor.vue?vue&type=template&id=76f6ed1c"
import script from "./textStyleEditor.vue?vue&type=script&lang=js"
export * from "./textStyleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports